import { createContext, useContext } from 'react';

import type { OptionListSummary } from '@src/models/interfaces/optionList.interface';

/**
 * What a selector field needs from the form being edited, without threading it through the
 * generic property inputs (`AVAILABLE_PROPS`): the divisions the form is saved for (which decide
 * the saved lists it may use), its name (to name converted lists), who may create or edit lists
 * and who owns a new one (see `useOptionListOwnership`), and the editor's "unsaved changes" flag
 * for changes made in code rather than typed. Outside the editor it is empty, so no list actions
 * are offered.
 */
export interface SelectFieldContextValue {
  organizationId?: string;
  /** Resolved like the save does; `[]` is an org-wide form. Undefined outside the editor. */
  divisionIds?: string[];
  formName?: string;
  onDirty?: () => void;
  /** Owning division of lists created here; `null` for org-wide. */
  ownerDivisionId?: string | null;
  canCreateList?: boolean;
  canEditList?: (list: Pick<OptionListSummary, 'divisionId'>) => boolean;
}

export const SelectFieldContext = createContext<SelectFieldContextValue>({});

export const useSelectFieldContext = () => useContext(SelectFieldContext);
